import Decimal from 'decimal.js';

import { CHAIN_ID } from '@constants/common/chain.constants';
import { AssetType, TokenSymbol } from '@constants/common/tokens.constants';

export class Token<TSymbol = string> {
  chainId: number;

  address: string;

  decimals: number;

  symbol: TSymbol;

  name: string | undefined;

  isLP: boolean | undefined;

  constructor(
    chainId: number,
    address: string,
    decimals: number,
    symbol: TSymbol,
    isLP?: boolean,
    name?: string,
  ) {
    this.chainId = chainId;
    this.address = address.toLowerCase();
    this.decimals = decimals;
    this.symbol = symbol;
    this.name = name;
    this.isLP = isLP;
  }
}

export type PropType<TObj, TProp extends keyof TObj> = TObj[TProp];

export type ChainInfo = {
  logo: string;
  inactiveLogo: string;
  whiteLogo?: string;
  name: string;
  walletName: string;
  blockExplorerUrl: string;
};

export type ChainMapped<T = any> = {
  [chainId in CHAIN_ID]: T;
};

export type TokenMapped = {
  [chainId in TokenSymbol]?: Token;
};

export interface TokenERC20 {
  address: string;
  decimals: number;
  name: string;
  symbol: string;
}

export interface TokenIconItem {
  address: string;
  chainId: number;
}

export interface AssetTokenBase {
  assetType: AssetType;
  tokenId?: number | null;
  address: string | null;
}

export type AssetToken = {
  assetType: AssetType;
  tokenId: number | null;
  address: string | null;
  icons: { address: string; chainId: number }[];
  symbol: string;
  balance: Decimal | null;
  balanceInUsd?: Decimal | null;
  fee: number | null;
  decimals: number | null;
  priceInUsd: string | null;
};
